import CockpitNotificationStateLookupResourceListResultModel from '../../generated/types/model/resource/CockpitNotificationStateLookupResourceListResultModel';

export default class CockpitNotificationStateLookupResourceListResultViewModel extends CockpitNotificationStateLookupResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
